/**
 * A page can hide filters on purpose (the make filter on /marka/{make}, where the URL already fixes
 * the make). PHP renders them as JSON, data-hidden-filters='{"brand":"toyota"}', on the mount node.
 * A hidden filter is not shown, but it stays applied: it is sent with every facets request, so the
 * facets and the "Pokaż x wyników" count match the listing. It is never part of the selection that
 * builds URLs (the page URL already carries it).
 */
export function parseHiddenFilters(value) {
    if (!value)
        return {};
    try {
        const parsed = JSON.parse(value);
        if (parsed === null || typeof parsed !== "object" || Array.isArray(parsed))
            return {};
        return Object.fromEntries(Object.entries(parsed).filter((entry) => typeof entry[1] === "string" && entry[1] !== ""));
    }
    catch (_a) {
        return {};
    }
}
/** Drops the hidden filters from a filter or path filter config list. */
export function withoutHiddenFilters(filters, hidden) {
    return Object.keys(hidden).length > 0 ? filters.filter((filter) => !(filter.id in hidden)) : filters;
}
/** The selection without the hidden filters: what chips, counts and submit URLs work with. */
export function withoutHiddenSelection(selected, hidden) {
    if (Object.keys(hidden).length === 0)
        return selected;
    return Object.fromEntries(Object.entries(selected).filter(([key]) => !(key in hidden)));
}
/** The selection with the hidden filters applied: what facets requests are made with. */
export function withHiddenFilters(selected, hidden) {
    return Object.keys(hidden).length > 0 ? Object.assign(Object.assign({}, selected), hidden) : selected;
}
